/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {simpleOvertimeReport} from '../api'

export const useMutationSimpleOvertimeReport = createReactQueryMutationHook('simpleOvertimeReport', simpleOvertimeReport)
